<header id="app-header">
  <div class="header-wrapper">
    <div class="page-card">
      <div class="card-controls">
        <div class="header-left">
          @if (haveBackButton) {
          <button
            class="back-button"
            (click)="back()"
            type="button"
            aria-label="Go back"
          >
            <img
              class="back-icon"
              src="../../assets/images/back-arrow.png"
              alt="Back"
            />
          </button>
          }
        </div>

        <div class="header-right">
          @if (currentPage.includes('profile') && !currentPage.includes('edit'))
          {
          <button
            class="edit-button"
            (click)="goToEditProfile()"
            type="button"
            aria-label="Edit profile"
          >
            Edit
          </button>
          }
        </div>
      </div>

      <div class="card-content">
        <div class="title-with-icon">
          <img
            class="page-logo"
            src="assets/reball/reball logo no bg.png"
            alt="ReBall"
          />
          <h1 class="page-title">{{ name }}</h1>
        </div>
        <p class="page-description" *ngIf="description">{{ description }}</p>
      </div>
    </div>
  </div>
</header>
